<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1 v-if="!editTopicName">
        Topic: {{this.$route.query.topic_name}} &nbsp; <i class="fa fa-pencil" aria-hidden="true"
          @click="this.onEditTopicName"></i> &nbsp;
      </h1>
      <form v-if="editTopicName"
        :style="{ width: '30%', display:'flex', 'justify-content': 'space-between', 'align-items':'center' }"
        @submit.prevent="updateTopicOrPrompt">
        <input type="text" :style="{width: '80%'}" :placeholder="this.$route.query.topic_name" v-model="topicName"
          required />
        <button type="submit"
          class="btn btn-rounded btn-remove-nudge btn-nudge btn-primary col-xs-2 col-sm-2 col-md-2 col-2"
          style="margin-right: 5px;"><i aria-hidden="true" class="fa fa-save"></i></button>
        <button type="button"
          class="btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2"
          @click="this.onEditTopicName" style="margin-right: 5px;"><i aria-hidden="true"
            class="fa fa-times"></i></button>
      </form>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li> NLP Topic-Label-Conversation Mappings</li>
        <li><a href="nlp_topic_list"> Mapping List</a></li>
        <li class="active">Mapping Detail</li>
      </ol>
    </section>
    <section class="content">
      <div class="row" style="margin-top: 15px;">
        <div class="col-md-12 col-lg-12 col-xs-12">
          
        <form style="dispay: flex;" @submit.prevent="updateTopicOrPrompt">
          <div class="form-group col-xs-5 col-sm-5 col-md-5">
            <label for="Prompt">Prompt</label>
            <treeselect 
              id="topic" 
              placeholder="--Choose NLP Topic--" 
              :multiple="false" 
              :options="promptList"
              v-model="promptId"
            />
          </div>
          <button type="submit"
            class="btn btn-rounded btn-remove-nudge btn-nudge margin-top-30 btn-primary col-xs-2 col-sm-2 col-md-2 col-2"
            style="margin-right: 5px;"><i aria-hidden="true" class="fa fa-save"></i></button>  
        </form>
          <div class="form-group col-xs-12 col-sm-12 col-md-12">
            <button type="button" class="action-btn action-btn-save" @click="addLabelMapping">
              <i class="fa fa-plus" aria-hidden="true"></i> Add New Label Mapping
            </button>
          </div>
        </div>
      </div>
      <div v-if="pageLoading" aria-busy="true" aria-label="Loading mappings">
        <div v-for="n in 3" :key="'skeleton-' + n" class="panel panel-default mapping-card skeleton-card">
          <div class="panel-body">
            <div class="skeleton-fields">
              <div class="skeleton-field skeleton-field-wide">
                <div class="sk sk-label"></div>
                <div class="sk sk-input"></div>
              </div>
              <div class="skeleton-field">
                <div class="sk sk-label"></div>
                <div class="sk sk-input"></div>
              </div>
              <div class="skeleton-field">
                <div class="sk sk-label"></div>
                <div class="sk sk-input"></div>
              </div>
              <div class="skeleton-actions">
                <div class="sk sk-button"></div>
                <div class="sk sk-button-icon"></div>
              </div>
            </div>
            <div class="mapping-footer skeleton-footer">
              <div class="sk sk-chip"></div>
              <div class="sk sk-toggles"></div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!pageLoading">
      <div v-for="(item, index) in mappingList" :key="index" ref="mappingCards">
        <div :class="{ 'wormhole-panel': item.hasAdditionalConfig }" class="panel panel-default mapping-card">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12 keyword-conversation-container">
                <div class="form-group col-xs-4 col-sm-4 col-md-4">
                  <label for="label" class="required">Label
                    <!-- <span title="Provide the label"><i class="fa fa-info-circle margin-10"></i></span> -->
                  </label>
                  <treeselect placeholder="--Choose or Enter label--" :multiple="false" :defaultOptions="true"
                    :load-options="loadOptions" :async="true" id="referral_source" v-model="item.label" search-nested
                    :cacheOptions="false" @select="addNewSource">
                    <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
                  </treeselect>
                </div>
                <div class="form-group col-xs-3 col-sm-3 col-md-3">
                  <label class="required">Conversation</label>
                  <treeselect placeholder="--Choose a conversation--" :multiple="false" :options="conversationList"
                    v-model="item.conversation_id"
                    @select="(node, id) => selectConversation(node, index)"
                    @input="(node, id) => updateStageList(node, index)"/>
                </div>

                <div class="form-group col-xs-3 col-sm-3 col-md-3">
                  <label class="nlp-convo-exit-mapping-label">Stage of Conversation</label>
                  <treeselect placeholder="--Choose a stage--" :multiple="false" :options="item.stageList"
                    v-model="item.additional_topic_mapping_details.stage" />
                </div>
                
                <div class="col-xs-2 col-sm-2 col-md-2 mapping-actions">
                  <button type="button" class="action-btn action-btn-save" :class="{ 'action-btn-dirty': isDirty(item) }"
                    :title="isDirty(item) ? 'You have unsaved changes. Click to save' : 'Save this mapping'" @click="saveMapping(index)">
                    <i class="fa fa-check" aria-hidden="true"></i> Save
                  </button>
                  <button type="button" class="action-btn action-btn-icon action-btn-delete" title="Delete this mapping" @click="removeMapping(index)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="mapping-footer">
              <div class="exit-mapping-summary">
                <span class="exit-mapping-title">End stage</span>
                <template v-if="exitMappingsFor(item).length">
                  <span v-for="(exit, exitIndex) in exitMappingsFor(item)" :key="exitIndex" class="exit-chip"
                    :title="exit.conversation + ' → ' + exit.stage">
                    <span class="exit-chip-convo">{{ exit.conversation }}</span>
                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                    <span class="exit-chip-stage">{{ exit.stage }}</span>
                  </span>
                </template>
                <span v-else class="exit-mapping-empty">Not set</span>
                <button type="button" class="action-btn action-btn-edit" title="Edit end stage mappings"
                  @click="showAddConversationMappingModal(index, item.id)">
                  <i class="fa fa-pencil" aria-hidden="true"></i> Edit
                </button>
              </div>
              <div class="mapping-options">
                <span v-if="isDirty(item)" class="unsaved-badge"><i class="fa fa-circle" aria-hidden="true"></i> Unsaved changes</span>
                <span v-else class="saved-badge"><i class="fa fa-check-circle" aria-hidden="true"></i> Saved</span>
                <label class="switch-option" title="When on, the bot skips the preamble message and sends the answer or conversation directly">
                  <input type="checkbox" v-model="item.additional_topic_mapping_details.skip_preamble" />
                  <span class="switch-track"><span class="switch-thumb"></span></span>
                  <span class="switch-text switch-text-primary">Skip preamble message</span>
                </label>
                <label class="switch-option" title="Also clear cached chatbot responses for this topic's conversations when you save">
                  <input type="checkbox" v-model="item.invalidateCache" />
                  <span class="switch-track"><span class="switch-thumb"></span></span>
                  <span class="switch-text">Invalidate cache</span>
                </label>
              </div>
            </div>
          </div>

        </div>
      </div>
      <button type="button" class="add-mapping-bottom" @click="addLabelMapping">
        <i class="fa fa-plus" aria-hidden="true"></i> Add New Label Mapping
      </button>
      </template>
    </section>
    <deleteConfirmationModal v-if="isDeleteConfirmationVisible" @close="closeConfirmationModal"
      @deleteMappingFromDB="deleteMappingFromDB" :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
      :confirmationMessage="confirmationMessage" :actionToBePerformed="actionToBePerformed" />
    <NlpConversationExitMapping v-if="isNlpConversationExitMappingVisible" 
      @close="closeExitMappingModal"
      :isNlpConversationExitMappingVisible="isNlpConversationExitMappingVisible" 
      :conversationList="conversationList" 
      :labelMappingId="currentSelectedMapping"
      :conversationExitMapping="selectedConversationExitMapping"
      :additionalTopicMappingDetails="selectedAdditionalTopicMapping"
      @updateConversationExitMapping="updateConversationExitMapping"
    />
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br />Please wait...</BlockUI>
  </div>
</template>
<script>
  import api from '../../../utils/api'
  import deleteConfirmationModal from './../popup/deleteConfirmation'
  import NlpConversationExitMapping from './../popup/nlpConversationExitMapping'
  import { Treeselect, ASYNC_SEARCH } from '@riophae/vue-treeselect'

  export default {
    name: 'modal',
    components: {
      'deleteConfirmationModal': deleteConfirmationModal,
      'NlpConversationExitMapping': NlpConversationExitMapping,
      Treeselect
    },
    data () {
      return {
        currentTopic: parseInt(this.$route.query.topicId),
        editTopicName: false,
        mappingList: [{
          id: null,
          topic_id: parseInt(this.$route.query.topicId),
          conversation_id: null,
          topic_name: null,
          label: null,
          stage: null,
          stageList: [],
          additional_topic_mapping_details: {
            conversation_exit_mapping: [],
            stage: null,
            skip_preamble: false
          },
          hasAdditionalConfig: false,
          savedSnapshot: null,
          invalidateCache: true
        }],
        selectedConversationExitMapping: [{
          parent_conversation: null,
          parent_conversation_id: null,
          stage: null,
          stageList: [
            {
              id: null,
              label: null
            }
          ]
        }],
        selectedAdditionalTopicMapping: {},
        currentSelectedMapping: null,
        topicName: this.$route.query.topic_name,
        promptId: this.$route.query.promptId,
        conversationList: [],
        confirmationMessage: 'Are you sure you want to delete this label conversation mapping?',
        actionToBePerformed: 'Add Topic Label mapping',
        isDeleteConfirmationVisible: false,
        isNlpConversationExitMappingVisible: false,
        rowIndexToBeUpdated: 0,
        loading: false,
        pageLoading: true,
        labels: [],
        promptList: []
      }
    },
    methods: {
      updateConversationExitMapping (conversationExitMapping, labelMappingId) {
        console.log('ConvExitMapping in updatemethod: ', conversationExitMapping)
        this.mappingList = this.mappingList.map(item => {
          if (item.id === labelMappingId) {
            return {
              ...item,
              additional_topic_mapping_details: {
                ...item.additional_topic_mapping_details,
                conversation_exit_mapping: conversationExitMapping
              },
              hasAdditionalConfig: conversationExitMapping && conversationExitMapping.length > 0 && conversationExitMapping[0].parent_conversation_id
            }
          }
          return item
        })
        console.log('This.mappinglist: ', this.mappingList)
      },
      snapshotOf (item) {
        const details = item.additional_topic_mapping_details || {}
        return JSON.stringify({
          label: item.label ? item.label.trim() : null,
          conversation_id: item.conversation_id,
          stage: details.stage || null,
          skip_preamble: details.skip_preamble === true
        })
      },
      isDirty (item) {
        return !item.id || item.savedSnapshot !== this.snapshotOf(item)
      },
      exitMappingsFor (item) {
        const exits = (item.additional_topic_mapping_details && item.additional_topic_mapping_details.conversation_exit_mapping) || []
        return exits.filter(exit => exit.parent_conversation_id).map(exit => {
          const convo = this.conversationList.find(c => c.id === exit.parent_conversation_id)
          return {
            conversation: convo ? convo.label : `#${exit.parent_conversation_id}`,
            stage: exit.stage || 'no stage'
          }
        })
      },
      onEditTopicName () {
        console.log('Editing topic name')
        this.editTopicName = !this.editTopicName
      },
      async updateTopicOrPrompt (e) {
        e.preventDefault()
        this.loading = true

        if (!this.topicName || this.topicName.trim() === '') {
          this.loading = false
          this.$swal({
            type: 'error',
            text: 'Please enter a valid topic name'
          })
          return
        }
        if (!this.promptId) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: 'Please select a valid prompt'
          })
          return
        }

        const saveResponse = await api.buildRequest('updateNlpTopic', 'POST', {
          topic: this.topicName,
          topicId: this.currentTopic,
          promptId: this.promptId
        })
        if (saveResponse.data.payload.error && saveResponse.data.payload.error.message) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: saveResponse.data.payload.error.message
          })
          return
        }
        if (saveResponse.status === 200) {
          this.loading = false
          this.$swal({
            type: 'success',
            text: 'Record updated successfully'
          })
          this.$router.replace({
            path: this.$route.path,
            query: {
              ...this.$route.query,
              topic_name: this.topicName,
              promptId: this.promptId
            }
          })
        }
        this.editTopicName = !this.editTopicName
        console.log('Updating topic name')
      },
      loadOptions ({ action, searchQuery, callback }) {
        if (!searchQuery) {
          callback(null, this.labels)
        }
        const escapedSearchQuery = searchQuery.replace(/"/g, '\\"')
        if (action === ASYNC_SEARCH) {
          const options = []
          options.push({id: escapedSearchQuery, label: `${searchQuery} (click to add new label)`, customLabel: searchQuery})
          this.labels.forEach(source => {
            if (source.customLabel.toLowerCase() === searchQuery.toLowerCase()) {
              options.shift()
              options.push(source)
            } else if (source.customLabel.toLowerCase().includes(searchQuery.toLowerCase())) {
              options.push(source)
            }
          })
          callback(null, options)
        }
      },
      addNewSource (event) {
        if (event.label.includes('click to add new source')) {
          this.labels.push({id: event.id, label: `${event.customLabel} (Recently Added)`, customLabel: event.customLabel})
        }
      },
      addLabelMapping () {
        this.mappingList.push({
          id: null,
          topic_id: this.currentTopic,
          conversation_id: null,
          topic_name: null,
          label: null,
          additional_topic_mapping_details: {
            conversation_exit_mapping: [],
            stage: null,
            skip_preamble: false
          },
          stageList: [],
          savedSnapshot: null,
          invalidateCache: true
        })
        this.$nextTick(() => {
          const cards = this.$refs.mappingCards
          const newCard = cards && cards[cards.length - 1]
          if (newCard) newCard.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
      },
      async populateStageList () {
        if (this.mappingList && this.mappingList.length > 0) {
          const conversationIds = this.mappingList.map((item) => {
            return item.conversation_id
          })
          if (!conversationIds || conversationIds.length === 0 || !conversationIds[0]) return
          const stageListResponse = await api.buildRequest(`get-app-config/${conversationIds}`, 'GET', {})
          if (stageListResponse.data.payload && stageListResponse.data.payload.length > 0) {
            stageListResponse.data.payload.forEach((item) => {
              this.mappingList.forEach((mappingItem, index) => {
                if (item.id === mappingItem.conversation_id) {
                  const newStageList = Object.keys(item.conversation_config.config.stages).map(stage => ({
                    id: stage,
                    label: stage
                  }))
                  this.$set(this.mappingList[index], 'stageList', newStageList)
                }
              })
            })
          } else {
            console.log('No stage list found for the selected conversation')
          }
        }
        console.log(this.conversationExitMapping)
      },
      selectConversation (selectedConversationId, currentMappingIndex) {
        if (selectedConversationId !== this.mappingList[currentMappingIndex].conversation_id) {
          this.mappingList[currentMappingIndex].additional_topic_mapping_details = {
            ...this.mappingList[currentMappingIndex].additional_topic_mapping_details,
            stage: null
          }
        }
      },
      async updateStageList (selectedConversationId, currentMappingIndex) {
        // Make sure conversation_id is not null
        if (selectedConversationId) {
          const fetchAppConfig = await api.buildRequest(`get-app-config/${selectedConversationId}`, 'GET', {})
          if (fetchAppConfig.data.payload && fetchAppConfig.data.payload.length > 0 &&
              fetchAppConfig.data.payload[0].conversation_config &&
              fetchAppConfig.data.payload[0].conversation_config.config &&
              fetchAppConfig.data.payload[0].conversation_config.config.stages &&
              Object.keys(fetchAppConfig.data.payload[0].conversation_config.config.stages).length > 0) {
            const config = Object.keys(fetchAppConfig.data.payload[0].conversation_config.config.stages)
            const newStageList = config.map((stage) => {
              return {
                id: stage,
                label: stage
              }
            })
            this.$set(this.mappingList[currentMappingIndex], 'stageList', newStageList)
          } else {
            console.log('No stage list found for the selected conversation')
          }
        } else {
          this.mappingList[currentMappingIndex].additional_topic_mapping_details = {
            ...this.mappingList[currentMappingIndex].additional_topic_mapping_details,
            stage: null
          }
          this.$set(this.mappingList[currentMappingIndex], 'stageList', [])
        }
      },
      async saveMapping (index) {
        const saveData = {
          id: this.mappingList[index].id,
          topic_id: this.mappingList[index].topic_id,
          conversation_id: this.mappingList[index].conversation_id,
          label: this.mappingList[index].label ? this.mappingList[index].label.trim().replace(/\\"/g, '"') : null,
          additional_topic_mapping_details: this.mappingList[index].additional_topic_mapping_details
        }
        if (!saveData.topic_id) {
          this.$swal({
            type: 'error',
            text: 'Please Select Topic from listing page'
          })
          return
        }
        if (!saveData.conversation_id || !saveData.label) {
          this.$swal({
            type: 'error',
            text: 'Please Select Label and conversation'
          })
          return
        }
        try {
          this.loading = true
          const saveResponse = await api.buildRequest('saveTopicMapping', 'POST', saveData)
          if (saveResponse.data.payload.error && saveResponse.data.payload.error.message) {
            this.loading = false
            this.$swal({
              type: 'error',
              text: saveResponse.data.payload.error.message
            })
            return
          }
          if (saveResponse.status === 200) {
            if (!this.mappingList[index].id) {
              this.mappingList[index].id = saveResponse.data.payload.data.id
            }
            this.$set(this.mappingList[index], 'savedSnapshot', this.snapshotOf(this.mappingList[index]))
            this.loading = false
            this.$swal({
              type: 'success',
              text: 'Mapping saved successfully'
            })
            try {
              await api.buildRequest('llm-cache/invalidate', 'POST', {
                type: 'label_mapping',
                topic_id: this.mappingList[index].topic_id,
                invalidate: this.mappingList[index].invalidateCache
              })
            } catch (err) {
              console.warn('Cache invalidation failed:', err.message)
            }
          }
        } catch (error) {
          console.log('error: ', error)
          this.loading = false
          console.log('err 4: ', error)
          this.$swal({
            type: 'error',
            text: 'An error occurred'
          })
        }
      },
      removeMapping (index) {
        if (this.mappingList[index].id == null) {
          this.mappingList.splice(index, 1)
        } else {
          this.actionToBePerformed = 'Delete Label Conversation Mapping'
          this.confirmationMessage = 'It will delete mapping of label and conversation from the system. Are you sure you want to delete this mapping?'
          this.isDeleteConfirmationVisible = true
          this.rowIndexToBeUpdated = index
        }
      },
      deleteMappingFromDB (index) {
        const removeData = this.mappingList[this.rowIndexToBeUpdated]
        this.loading = true
        var self = this
        api.buildRequest('deleteNlpTopicLabelMapping', 'POST', {id: removeData.id})
        .then(response => {
          self.loading = false
          if (response.status === 200) {
            self.isDeleteConfirmationVisible = false
            this.$swal({
              type: 'success',
              text: response ? response.data.payload.message : 'Nlp label mapping deleted successfully'
            }).then(() => {
              self.mappingList.splice(self.rowIndexToBeUpdated, 1)
              self.rowIndexToBeUpdated = 0
            })
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          self.rowIndexToBeUpdated = 0
          self.isDeleteConfirmationVisible = false
          console.log('err 1: ', response)
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      showAddConversationMappingModal (index, selectedItemId) {
        if (!selectedItemId) {
          this.$swal({
            type: 'error',
            text: 'Please save this mapping before editing its end stage mappings'
          })
          return
        }
        this.selectedConversationExitMapping = [{
          parent_conversation: null,
          parent_conversation_id: null,
          stage: null,
          stageList: [
            {
              id: null,
              label: null
            }
          ]
        }]
        this.isNlpConversationExitMappingVisible = true
        this.currentSelectedMapping = selectedItemId
        if (this.mappingList[index] && this.mappingList[index].additional_topic_mapping_details &&
            this.mappingList[index].additional_topic_mapping_details.conversation_exit_mapping &&
            this.mappingList[index].additional_topic_mapping_details.conversation_exit_mapping.length > 0
        ) {
          this.selectedConversationExitMapping = this.mappingList[index].additional_topic_mapping_details.conversation_exit_mapping
        }
        this.selectedAdditionalTopicMapping = this.mappingList[index].additional_topic_mapping_details
      },
      closeConfirmationModal () {
        this.isDeleteConfirmationVisible = false
      },
      closeExitMappingModal () {
        this.isNlpConversationExitMappingVisible = false
      },
      async getConversationList () {
        try {
          const response = await api.buildRequest('getDeployedApps', 'GET', {})
          for (let app of response.data.payload) {
            this.conversationList.push({ id: app.id, label: app.appName.trim() })
          }
        } catch (error) {
          console.log('error: ', error)
        }
      },
      async getLabels (topicId) {
        try {
          const response = await api.buildRequest('getLabelList', 'POST', { journeyId: topicId })
          const data = response.data.payload.labels

          console.log('data: ', data)
          data.forEach(ele => {
            this.labels.push({id: ele, label: ele, customLabel: ele})
          })
        } catch (err) {
          console.log('err 2: ', err)
          this.$swal({
            type: 'error',
            text: err.response ? err.response.data.payload.message : 'An error occurred'
          })
        }
      },
      async getMappingDetails (topicId) {
        try {
          const response = await api.buildRequest('getNlpTopicMappingDetails', 'POST', { topicId: topicId })
          const data = response.data.payload
          if (data.mappingDetails.length) {
            console.log(data.mappingDetails)
            data.mappingDetails.forEach(item => {
              console.log('ITEM : ', item)
              if (item.additional_topic_mapping_details && item.additional_topic_mapping_details.conversation_exit_mapping &&
                item.additional_topic_mapping_details.conversation_exit_mapping.length && item.additional_topic_mapping_details.conversation_exit_mapping[0].parent_conversation_id
              ) {
                item.hasAdditionalConfig = true
              }
              if (!item.additional_topic_mapping_details) {
                item.additional_topic_mapping_details = {}
              }
              item.additional_topic_mapping_details.skip_preamble = item.additional_topic_mapping_details.skip_preamble === true
              item.savedSnapshot = this.snapshotOf(item)
              item.invalidateCache = true
            })
            this.mappingList = data.mappingDetails
            console.log('mappingList: ', this.mappingList)
          }
        } catch (err) {
          console.log('err 3: ', err)
          this.$swal({
            type: 'error',
            text: err.response ? err.response.data.payload.message : 'An error occurred'
          })
        }
      },
      getAllPrompts () {
        return api.buildRequest('getAllPrompts', 'POST', {})
          .then(response => {
            if (response.status === 200) {
              this.promptList = response.data.payload.prompts.map(prompt => { return { id: prompt.id, label: prompt.prompt_name } })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      }
    },
    async mounted () {
      try {
        const hasTopic = this.$route && this.$route.query && this.$route.query.topicId
        await Promise.all([
          this.getConversationList(),
          this.getAllPrompts(),
          hasTopic ? this.getMappingDetails(this.$route.query.topicId) : null,
          hasTopic ? this.getLabels(this.$route.query.topicId) : null
        ])
        await this.populateStageList()
      } finally {
        this.pageLoading = false
      }
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.form-group .padding-15px {
  padding: 0 15px;
}

.mapping-card {
  margin: 0 15px 12px;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);
  transition: box-shadow 0.2s;
}
.mapping-card:hover {
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.12);
}
.mapping-card .panel-body {
  padding: 12px 15px 15px;
}
.mapping-card .keyword-conversation-container .form-group {
  margin-bottom: 10px;
}
.mapping-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 24px;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s;
}
.action-btn:focus-visible {
  outline: 2px solid #0D9488;
  outline-offset: 2px;
}
.action-btn-icon {
  width: 34px;
  padding: 0;
}
.action-btn-save {
  background: #0B7C72;
  color: #fff;
}
.action-btn-save:hover {
  background: #2c6a90;
  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.3);
}
.action-btn-dirty {
  background: #e08e0b;
}
.action-btn-dirty:hover {
  background: #c97d08;
  box-shadow: 0 2px 6px rgba(224, 142, 11, 0.4);
}
.unsaved-badge,
.saved-badge {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.unsaved-badge {
  color: #b45309;
}
.saved-badge {
  color: #15803d;
}
.action-btn-delete {
  background: #fff;
  border-color: #e3e8ef;
  color: #6b7280;
}
.action-btn-delete:hover {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #dc2626;
}
.action-btn-edit {
  height: 28px;
  padding: 0 10px;
  background: #fff;
  border-color: #b9d6e8;
  color: #2c6a90;
  font-size: 12px;
}
.action-btn-edit:hover {
  background: #e6f1f8;
}
.mapping-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 24px;
  margin: 2px -15px -15px;
  padding: 8px 30px;
  background: #f8f9fc;
  border-top: 1px solid #eceef3;
  border-radius: 0 0 11px 11px;
}
.exit-mapping-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.exit-mapping-title {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
}
.exit-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 14px;
  background: #e6f1f8;
  color: #1f5f86;
  font-size: 13px;
}
.exit-chip-convo {
  overflow-wrap: anywhere;
}
.exit-chip-stage {
  font-weight: 600;
  white-space: nowrap;
}
.exit-mapping-empty {
  font-size: 13px;
  color: #9ca3af;
}
.mapping-options {
  display: flex;
  align-items: center;
  gap: 24px;
}
.mapping-options .switch-option + .switch-option {
  padding-left: 24px;
  border-left: 1px solid #dfe2e8;
}
.switch-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
  font-weight: normal;
}
.switch-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.switch-track {
  position: relative;
  flex: none;
  width: 32px;
  height: 18px;
  border-radius: 9px;
  background: #c4cad4;
  transition: background 0.2s;
}
.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
}
.switch-option input:checked + .switch-track {
  background: #0D9488;
}
.switch-option input:checked + .switch-track .switch-thumb {
  transform: translateX(14px);
}
.switch-option input:focus-visible + .switch-track {
  outline: 2px solid #0D9488;
  outline-offset: 2px;
}
.switch-text {
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
}
.switch-text-primary {
  color: #1f2937;
  font-weight: 600;
}

.add-mapping-bottom {
  display: block;
  width: calc(100% - 30px);
  margin: 0 15px 24px;
  padding: 12px;
  border: 2px dashed #b9d6e8;
  border-radius: 12px;
  background: transparent;
  color: #2c6a90;
  font-size: 14px;
  font-weight: 600;
  transition: background 0.15s, border-color 0.15s;
}
.add-mapping-bottom:hover {
  background: #e6f1f8;
  border-color: #0D9488;
}
.add-mapping-bottom:focus-visible {
  outline: 2px solid #0D9488;
  outline-offset: 2px;
}
.skeleton-fields {
  display: flex;
  align-items: flex-end;
  gap: 30px;
  padding: 0 15px;
}
.skeleton-field {
  flex: 1 1 0;
}
.skeleton-field-wide {
  flex: 1.4 1 0;
}
.skeleton-actions {
  display: flex;
  gap: 8px;
  width: 130px;
}
.skeleton-footer {
  justify-content: space-between;
}
.sk {
  background: linear-gradient(90deg, #eceff3 25%, #f6f8fa 37%, #eceff3 63%);
  background-size: 400% 100%;
  animation: sk-shimmer 1.4s ease infinite;
  border-radius: 6px;
}
.sk-label { width: 40%; height: 12px; margin-bottom: 10px; }
.sk-input { height: 38px; }
.sk-button { width: 80px; height: 34px; border-radius: 8px; }
.sk-button-icon { width: 34px; height: 34px; border-radius: 8px; }
.sk-chip { width: 340px; max-width: 50%; height: 26px; border-radius: 14px; }
.sk-toggles { width: 300px; max-width: 40%; height: 18px; }
@keyframes sk-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
@media (prefers-reduced-motion: reduce) {
  .sk { animation: none; }
}

/* mappings that have conversation exit config get a purple accent bar */
.wormhole-panel {
  border-left: 4px solid #0D9488;
}
</style>


// WEBPACK FOOTER //
// nlpTopicMappingDetails.vue?2117e7eb